import React, { useState } from "react";
import { Button, Typography, IconButton, makeStyles } from "@material-ui/core";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import checkImg from "../assets/icons/check_circle.png";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));

export default function AlertDialog({
  title,
  contentMsg,
  type,
  resendAction,
  deleteAction,
  publishAction,
  copyAction,
  termAction,
  cancelSaveAction,
  closeDialog,
  goScorePageAction,
  goPublishFormPageAction,
  activeDeactiveUserFunc,
  activeDeactiveUserButn,
  goDonwloadApplicantAction,
  headerMsg,
  termCompletedWarning,
  termCompletedOkAction,
  termCompletedCancelAction,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  const handleTerm = () => {
    setOpen(false);
    termAction && termAction();
  };
  const handleDelete = () => {
    setOpen(false);
    deleteAction && deleteAction();
  };
  const handleResend = () => {
    setOpen(false);
    resendAction && resendAction();
  };
  const handleCopy = () => {
    setOpen(false);
    copyAction && copyAction();
  };

  const handlePublish = () => {
    setOpen(false);
    publishAction && publishAction();
  };
  const handleCancelSave = () => {
    setOpen(false);
    cancelSaveAction && cancelSaveAction();
  };
  const handleGoScorePageAction = () => {
    setOpen(false);
    goScorePageAction && goScorePageAction();
  };
  const handleConfirmDownloadApplicant = () => {
    setOpen(false);
    goDonwloadApplicantAction && goDonwloadApplicantAction();
  };
  const handlegGoPublishFormPageAction = () => {
    setOpen(false);
    goPublishFormPageAction && goPublishFormPageAction();
  };

  const handleActiveDeactiveUserFunc = () => {
    setOpen(false);
    activeDeactiveUserFunc && activeDeactiveUserFunc();
  };

  const handleTermCompletedOk = () => {
    setOpen(false);
    termCompletedOkAction && termCompletedOkAction();
  };

  const handleTermCompletedCancel = () => {
    setOpen(false);
    termCompletedCancelAction && termCompletedCancelAction();
  };

  return (
    <div style={{ width: "90%" }}>
      {type && type === "Done" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onKeyDown={e => {
            e.key === "Enter" && handleClose();
          }}
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "end" }}
          ></DialogTitle>
          <DialogContent
            onKeyDown={e => {
              e.key === "Enter" && console.log("hi");
            }}
            style={{ textAlign: "center" }}
          >
            <img src={checkImg} />
            <Typography
              variant="h3"
              style={{ fontSize: 20, paddingTop: 20, paddingBottom: 10 }}
            >
              {title}
            </Typography>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="text"
                onClick={handleClose}
                //  color="primary"
                className={classes.buttonStyle}
              >
                Ok
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
      {type && type === "resendActivationConfirmation" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              For Staff: {headerMsg}
              <br />
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={resendAction ? handleResend : handleClose}
              >
                Resend
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
      {type && type === "deleteConfirmation" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={deleteAction ? handleDelete : handleClose}
              >
                Delete
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
      {type && type === "publishConfirmation" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={publishAction ? handlePublish : handleClose}
              >
                OK
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
      {type && type === "copyConfirmation" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={copyAction ? handleCopy : handleClose}
              >
                OK
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {type && type === "termConfirmation" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Center" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>

          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={handleClose}
              >
                DONE
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {type && type === "saveConfirmation" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={cancelSaveAction ? handleCancelSave : handleClose}
              >
                Exit
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Stay
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {type && type === "goFormScoresPage" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5, height: 34, width: 200 }}
                onClick={handleGoScorePageAction}
              >
                Go to Form Scores Page
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {type && type === "goPublishFormPage" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={handlegGoPublishFormPageAction}
              >
                Done
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {type && type === "activeDeactiveUser" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5 }}
                onClick={
                  activeDeactiveUserFunc ? handleActiveDeactiveUserFunc : handleClose
                }
              >
                {activeDeactiveUserButn}
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {type && type === "downloadApplicantsReport" && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5, height: 34, width: 100 }}
                onClick={handleConfirmDownloadApplicant}
              >
                Yes, Run
              </Button>
              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {type && type === "termCompletedWarning" && (
        <Dialog
          open={open}
          onClose={handleTermCompletedCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>

            {closeDialog && (
              <IconButton
                aria-label="close"
                onClick={handleTermCompletedCancel}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </DialogTitle>

          <DialogContent style={{ textAlign: "Left" }}>
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>

          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 5, height: 34, width: 100 }}
                onClick={handleTermCompletedOk}
              >
                OK
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={handleTermCompletedCancel}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {!type && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onKeyDown={e => {
            e.key === "Enter" && handleClose();
          }}
        >
          <DialogTitle
            sx={{ m: 0, p: 2 }}
            id="alert-dialog-title"
            style={{
              display: "flex",
              justifyContent: "space-between",
              minWidth: 300,
            }}
          >
            <Box mt={1} ml={1}>
              {title}
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          {headerMsg && (
            <DialogContent
              style={{
                paddingBottom: 0,
              }}
            >
              <DialogContentText
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                }}
                id="alert-dialog-description"
              >
                {headerMsg}
              </DialogContentText>
            </DialogContent>
          )}
          <DialogContent
            style={{
              paddingTop: 0,
            }}
          >
            <DialogContentText id="alert-dialog-description">
              {contentMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Box mb={2}>
              <Button
                variant="text"
                onClick={handleClose}
                color="primary"
                className={classes.buttonStyle}
              >
                OK
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
